<template>
  <div class="index">
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>基本信息</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品名称：</div>
            <div class="value" style="max-width: 180px;" :title="get.name">{{get.name}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">商品状态：</div>
            <div class="value" style="max-width: 180px;" :title="get.importStatus">{{get.importStatus}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">引入区域：</div>
            <div class="value" style="max-width: 180px;" :title="get.importPlace">{{get.importPlace}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品编码：</div>
            <div class="value" :title="get.code">{{get.code}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">分类编码：</div>
            <div class="value" :title="get.categoryCode">{{get.categoryCode}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">商品标签：</div>
            <div class="value" :title="get.productLabel">{{get.productLabel}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品分类：</div>
            <div class="value" :title="category">{{category}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">区域化品名：</div>
            <div class="value" :title="get.alias">{{get.alias}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">产业规模：</div>
            <div class="value" :title="get.industrySize">{{get.industrySize}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">商品定位：</div>
            <div class="value" :title="get.positioning">{{get.positioning}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.images">
        <el-col :span="24">
          <div>
            <div class="key">商品图片：</div>
            <div class="value">
              <ProductImages :images="get.images" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品属性：</div>
            <div class="value" :title="get.features">{{get.features}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">存储方法：</div>
            <div class="value">{{get.storageMeans}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.storageMeansImages">
        <el-col :span="24">
          <div>
            <div class="key">存储方法图片：</div>
            <div class="value">
              <ProductImages :images="get.storageMeansImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>商品特色</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品特色：</div>
            <div class="value">{{get.productFeature}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.productFeatureImages">
        <el-col :span="24">
          <div>
            <div class="key">商品特色图片：</div>
            <div class="value">
              <ProductImages :images="get.productFeatureImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>生长习性</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">商品产地</div>
            <div class="value">{{get.place}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.placeImages">
        <el-col :span="24">
          <div>
            <div class="key">商品产地图片：</div>
            <div class="value">
              <ProductImages :images="get.placeImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">生长周期：</div>
            <div class="value">{{get.lifeCycles}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.lifeCyclesImages">
        <el-col :span="24">
          <div>
            <div class="key">生长周期图片：</div>
            <div class="value">
              <ProductImages :images="get.lifeCyclesImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">上市时间：</div>
            <div class="value">{{get.timeToMarket}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">加工流程：</div>
            <div class="value">{{get.processFlow}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.processFlowImages">
        <el-col :span="24">
          <div>
            <div class="key">加工流程图片：</div>
            <div class="value">
              <ProductImages :images="get.processFlowImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">验收标准：</div>
            <div class="value" :title="get.acceptanceStandard">{{get.acceptanceStandard}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.acceptanceStandardImages">
        <el-col :span="24">
          <div>
            <div class="key">验收标准图片：</div>
            <div class="value">
              <ProductImages :images="get.acceptanceStandardImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>食赏妙味</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">挑选窍门：</div>
            <div class="value">{{get.chooseTrick}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.chooseTrickImages">
        <el-col :span="24">
          <div>
            <div class="key">挑选窍门图片：</div>
            <div class="value">
              <ProductImages :images="get.chooseTrickImages" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">食用方法：</div>
            <div class="value">{{get.edibleMethods}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row" v-if="get.edibleMethodsImages">
        <el-col :span="24">
          <div>
            <div class="key">食用方法图片：</div>
            <div class="value">
              <ProductImages :images="get.edibleMethodsImages" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ProductImages from "@/components/ProductImages.vue";
export default {
  name: "ProductBase",
  components: {
    ProductImages
  },
  props: ["get", "category"]
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;

  font-size: 14px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .row {
    line-height: 20px;
    min-height: 50px;
    padding: 15px 20px;
  }

  .content .row:nth-child(2n + 1) {
    background: #f7faf8;
  }

  // .row-dark {
  //   background: #f7faf8;
  // }

  .key {
    display: inline-block;
    width: 100px;
    color: #666;
    vertical-align: top;
  }
  .value {
    display: inline-block;
    max-width: 760px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    width: 70%;
  }
}
</style>
